module.exports = __webpack_public_path__ + "img/producto-camara.a9d3b9d5.png";